
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulicPipe03 as ObiHydraulicPipe03Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-pipe-03.js';
 
 
 

 
 export const ObiHydraulicPipe03 = createComponent({
   react: React,
   tagName: 'obi-hydraulic-pipe-03',
   elementClass: ObiHydraulicPipe03Element,
   events: {
     
   }
  });
 
 